import React, { useLayoutEffect, useRef } from 'react'

const TimeComponent = React.memo(
  ({ focus, active, rowData, setRowData }) => {
    const ref = useRef(null)

    // This is the same trick as in `textColumn`
    useLayoutEffect(() => {
      if (focus) {
        ref.current?.focus()
      } else {
        ref.current?.blur()
      }
    }, [focus])

    return (
      <input
        className="w-full h-full border-none bg-transparent"
        type="time"
        // Important to prevent any undesired "tabbing"
        tabIndex={-1}
        ref={ref}
        // The `pointerEvents` trick is the same than in `textColumn`
        // Only show the calendar symbol on non-empty cells, or when cell is active, otherwise set opacity to 0
        style={{
          pointerEvents: focus ? 'auto' : 'none',
          opacity: rowData || active ? undefined : 0,
        }}
        // Because rowData is a Date object and we need a string, we use toISOString...
        value={rowData || ""}
        // ...and the input returns a string that should be converted into a Date object
        onChange={(e) => {
            setRowData(`${e.target.value}${e.target.value.length < 8 ? ":00" : ""}`)
        }}
      />
    )
  }
)

TimeComponent.displayName = 'TimeComponent'

export const timeColumn = {
  component: TimeComponent,
  deleteValue: () => null,
  // We convert the date to a string for copying using toISOString
  copyValue: ({ rowData }) =>
    rowData,
  // Because the Date constructor works using iso format, we can use it to parse ISO string back to a Date object
  pasteValue: ({ value }) => {
    return value
  },
  minWidth: 170,
  isCellEmpty: ({ rowData }) => !rowData,
}